// Path: src\Components\Home\Banner.jsx
import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import BannerImg from '../../images/banner.png';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import "swiper/css/effect-fade";

import { Navigation, Pagination, Scrollbar, A11y, EffectCoverflow, EffectCards, Autoplay } from 'swiper/modules';
import { bannerList } from "../../api/banner.api";
import { url } from "../../config/url";
import SwiperCore from 'swiper';
import { bannerRedirection } from "../common";
import { useNavigate } from "react-router";
// Install Swiper modules
SwiperCore.use([EffectCoverflow, Pagination]);
export const initialFilter = {
    pagination: {
        pageNo: 1,
        recordPerPage: 100,
        sortBy: "order",
        sortDirection: "asc"
    },
    search: {
        isActive: true
    },
};

const Banner = ({ data ,setLoading}) => {
    const [filter, setFilter] = useState(initialFilter);
    const [list, setList] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true)
        fetchBanners();
    }, [])

    const fetchBanners = async () => {
        try {
            let data = filter;
            const res = await bannerList(data);
            if (res?.success && res?.data?.length > 0) {
                setList(res?.data)
            }
            else {
                setList([]);
            }
            
        } catch (error) {
        }
        setLoading(false)
    };

    const onClickBannerAdOwlCarousel = (value) => {
        if (value.url === "" || value.url === null) {
            var url_redirection = bannerRedirection(value);
            navigate(url_redirection);
        } else {
            const trimmedUrl = value.url.startsWith('/') ? value.url.slice(1) : value.url;
            // navigate(`/${trimmedUrl}`); // Add leading slash for relative navigation
            window.open(
                trimmedUrl,
                "_blank" // <- This is what makes it open in a new window.
            );
        }
    };
    
    // function bannerRedirection(banner_data) {
    //     let gameType = banner_data?.gameType;
    //     var url_redirection = '';
    //     switch (banner_data?.screen?.code) {
    //         case 'viewAllEsportsNews':
    //             url_redirection = '/world-of-eports';
    //             break;
    //     }
    //     return url_redirection;
    // }

    return (
        list?.length > 0 ?
            <section className='banner points-swiper0-slide'>
                <Swiper
                //  effect={'coverflow'}
                //     modules={[Navigation, Pagination, Scrollbar, A11y]}
                //     spaceBetween={20}
                //     slidesPerView={1}
                //     onSlideChange={() => console.log('slide change')}
                //     onSwiper={(swiper) => console.log(swiper)}
                //     className='bannerSlider'
                //     autoplay={{
                //         delay: 3000,  // Delay between slides in ms (3 seconds here)
                //     }}
                onSlideChange={(swiper) => {
                    document.querySelectorAll(".swiper-slide").forEach((slide) => {
                      slide.classList.remove("active-slide");
                    });
                    swiper.slides[swiper.activeIndex].classList.add("active-slide");
                  }}
                effect={'coverflow'}
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={3} 
                initialSlide={Math.floor(list?.length / 2)} // Set the initial centered slide
                loop={false}      // Show only one image at a time
                coverflowEffect={{
                  rotate: 0,            // No rotation since we're using V shape
                  stretch: 0,
                  depth: 100,
                  modifier: 1,
                  slideShadows: false,  // Disable shadows for simplicity
                }}

                pagination={{ clickable: true }}
                className="mySwiper"
                breakpoints={{
                    400: {
                        slidesPerView: 5
                    }
                }}
                >

                    {list?.map((item, index) => {
                        return (
                            <SwiperSlide className='fading-slide'>
                                <div className='banner-img swipper-image-card'>
                                    <img className='' src={url?.IMAGE_URL + item?.img?.default} alt='banner' onClick={() => onClickBannerAdOwlCarousel(item)} />
                                </div>

                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </section>
            :
            <></>
    )
}

export default Banner